// User Model
import { Model } from '@vuex-orm/core';

export class Company extends Model {
    static entity = 'companies';

    static fields() {
        return {
            id: this.attr(null),
            address_city: this.attr(null),
            address_number: this.attr(null),
            address_street: this.attr(null),
            address_zip: this.attr(null),
            company_id: this.attr(null),
            country: this.attr(null),
            name: this.attr(null),
            email_taxation_documentation: this.attr(null),
            email_taxation_documentation_verified_at: this.attr(null)
        };
    }
}

export default Company;
